import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import Home from './Components/Home/Home';
import Points from './Components/Points/Points';
import Main from './Components/Weather/Main';
import Temperature from './Components/Temperature/Temperature';
import RawView from './Components/Raw View/RawView';
import Head from './Components/Head/Head';
import Message from './Components/Message/Message';


function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/weather" element={<Main />} />
        <Route path="/points" element={<Points />} />
        <Route path="/temperature" element={<Temperature />} />
        <Route path="/rawview" element={<RawView />} />
        <Route path="/message" element={<Message />} />
        </Routes>
       
      </BrowserRouter>
    </div>
  );
}

export default App;
